<template>
  <auth-layout ilustracao="email" :slides="slides">
    <div class="form">
      <h1 class="form__title">Verifique seu e-mail</h1>
      <p class="form__sub">
        <template v-if="email">
          Enviamos um link de confirmação para <strong>{{ email }}</strong>.
        </template>
        <template v-else>
          Se você acabou de se cadastrar, enviamos um link de confirmação para o e-mail informado.
        </template>
        Clique nele para ativar sua conta e liberar o login.
      </p>

      <div class="notice">Não encontrou? Dá uma olhada na caixa de spam ou lixo eletrônico.</div>

      <router-link class="btn" :to="{ name: 'login' }">Ir para o login</router-link>
    </div>
  </auth-layout>
</template>

<script>
import AuthLayout from "@/components/auth/AuthLayout.vue";

export default {
  components: { AuthLayout },
  props: {
    email: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    slides: [
      { titulo: "Quase lá", subtitulo: "Confirme o e-mail para liberar o acesso à plataforma." },
    ],
  }),
};
</script>

<style scoped src="@/components/auth/auth-form.css"></style>
